
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "GrowthSection",
  props: {
    growth: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  setup(props) {
    // The x-axis must come from whichever series is dense. `dau` is built by a
    // day-by-day loop on the backend and `newUsers` is now zero-filled to match, but
    // taking the longer of the two means a future gap in either one can't silently
    // plot DAU against the wrong dates again.
    const labels = computed(() => {
      const newUsers = props.growth.newUsers ?? [];
      const dau = props.growth.dau ?? [];
      const longest = dau.length >= newUsers.length ? dau : newUsers;
      return longest.map((p: any) => p.date.slice(0, 10));
    });

    const series = computed(() => [
      { name: "New users", data: (props.growth.newUsers ?? []).map((p: any) => p.value) },
      { name: "DAU", data: (props.growth.dau ?? []).map((p: any) => p.value) },
    ]);

    const chartOptions = computed(() => ({
      chart: { toolbar: { show: false }, background: "transparent" },
      stroke: { curve: "smooth", width: 2 },
      xaxis: { categories: labels.value, labels: { style: { colors: "#fff" } } },
      yaxis: { labels: { style: { colors: "#fff" } } },
      legend: { labels: { colors: "#fff" } },
      tooltip: { theme: "dark" },
      dataLabels: { enabled: false },
      colors: ["#F50242", "#4FC3F7"],
    }));

    // Onboarding funnel: [{ name: "Step1".."Step6" | "Completed" | "SocialFirstStep",
    // value }] — where users get stuck. Rendered as a horizontal bar, matching the
    // GeographySection convention.
    const funnel = computed(() => props.growth.onboardingFunnel ?? []);
    const funnelSeries = computed(() => [
      { name: "Users", data: funnel.value.map((x: any) => Number(x.value)) },
    ]);
    const funnelOptions = computed(() => ({
      chart: { toolbar: { show: false }, background: "transparent" },
      plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
      xaxis: {
        categories: funnel.value.map((x: any) => x.name),
        labels: { style: { colors: "#fff" } },
      },
      yaxis: { labels: { style: { colors: "#fff" } } },
      tooltip: { theme: "dark" },
      dataLabels: { enabled: false },
      colors: ["#4FC3F7"],
    }));

    return { series, chartOptions, funnel, funnelSeries, funnelOptions };
  },
});
